// Bounds [minLng, minLat, maxLng, maxLat]
// 瓦片更新显示策略
export var UpdateTileStrategy;

(function (UpdateTileStrategy) {
  UpdateTileStrategy["Realtime"] = "realtime";
  UpdateTileStrategy["Overlap"] = "overlap";
  UpdateTileStrategy["Replace"] = "replace";
})(UpdateTileStrategy || (UpdateTileStrategy = {}));

export var LoadTileDataStatus;

(function (LoadTileDataStatus) {
  LoadTileDataStatus["Loading"] = "Loading";
  LoadTileDataStatus["Loaded"] = "Loaded";
  LoadTileDataStatus["Failure"] = "Failure";
  LoadTileDataStatus["Cancelled"] = "Cancelled";
})(LoadTileDataStatus || (LoadTileDataStatus = {}));